import simpleFetch from "../../../../../../utils/simpleFetch";

class PremiumSimulatorApi {
  static submit(clientId, body, headers, options, query) {
    const path = `/v1/clients/${clientId}/simulate-premiums`;
    return simpleFetch("post", path, { body, headers, options, query });
  }
}

export default PremiumSimulatorApi;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/premiumSimulatorApi.js